import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class ClientFileService {
  static async getFiles (params) {
    const { data } = await axios.get(`${url}/files`, { headers, params })
    return data
  }

  static async getFile (fileId) {
    const { data } = await axios.get(`${url}/file/${fileId}`, { headers })
    return data
  }

  static async createFile (file) {
    const { data } = await axios.post(`${url}/file/`, file, { headers })
    return data
  }

  static async updateFile (file) {
    const { data } = await axios.put(`${url}/file/${file.fileId}`, file, { headers })
    return data
  }
}
